// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"a56f4180","79":"6e04e781","682":"e4814a09"}[chunkId] + ".chunk.js";
};